const FOOTER_LINKS = [
  {
    title: '快速导航',
    items: [
      { label: '人气排行', href: '#ranking' },
      { label: '最新动态', href: '#updates' },
      { label: '精选推荐', href: '#cards' },
      { label: '焦点专题', href: '#carousel' },
      { label: '主题索引', href: '#index' },
    ],
  },
  {
    title: '帮助中心',
    items: [
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '关于我们', href: '#about' },
      { label: '移动阅读', href: '#app' },
      { label: '特色优势', href: '#features' },
    ],
  },
];

const handleNavClick = (href: string) => {
  const el = document.querySelector(href);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
              className="font-heading text-2xl whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'var(--font-heading)', color: 'oklch(var(--foreground-50))' }}
            >
              韩国漫画
            </a>
            <p className="mt-4 text-sm leading-relaxed" style={{ color: 'oklch(var(--foreground-300))' }}>
              精选好看的韩国漫画推荐与排行榜，涵盖免费韩国漫画大全、高分必看作品。在线看人气韩国漫画，发现你的下一部韩国漫画。
            </p>
          </div>

          {FOOTER_LINKS.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base mb-4" style={{ fontFamily: 'var(--font-heading)', color: 'oklch(var(--foreground-50))' }}>
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                      className="text-sm cursor-pointer transition-colors hover:text-primary-400 whitespace-nowrap"
                      style={{ color: 'oklch(var(--foreground-400))' }}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading text-base mb-4" style={{ fontFamily: 'var(--font-heading)', color: 'oklch(var(--foreground-50))' }}>
              合作伙伴
            </h4>
            <p className="text-sm" style={{ color: 'oklch(var(--foreground-400))' }}>
              更多优质内容平台持续接入中
            </p>
          </div>
        </div>

        <div className="border-t pt-8 flex flex-col sm:flex-row items-center justify-between gap-4" style={{ borderColor: 'oklch(var(--foreground-800))' }}>
          <p className="text-xs" style={{ color: 'oklch(var(--foreground-500))' }}>
            &copy; {new Date().getFullYear()} 韩国漫画 版权所有
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }} className="text-xs cursor-pointer hover:text-primary-400 whitespace-nowrap" style={{ color: 'oklch(var(--foreground-500))' }}>首页</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); handleNavClick('#about'); }} className="text-xs cursor-pointer hover:text-primary-400 whitespace-nowrap" style={{ color: 'oklch(var(--foreground-500))' }}>关于我们</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); handleNavClick('#faq'); }} className="text-xs cursor-pointer hover:text-primary-400 whitespace-nowrap" style={{ color: 'oklch(var(--foreground-500))' }}>常见问题</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }} className="text-xs cursor-pointer hover:text-primary-400 whitespace-nowrap" style={{ color: 'oklch(var(--foreground-500))' }}>联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}